<template>
  <div>
    <Loader :loading='loading' />
    <div class="home container-fluid mt-md-3" v-if="!loading">
      <div class="row search-from-search d-md-none align-items-center">
        <div class="col-8">
          <SearchForm />
        </div>
        <div class="col-4 text-right">
          <el-button type="default" icon="el-icon-s-grid" class='filter-btn' 
            data-toggle="collapse" href="#collapseElm" size="small">
            FILTER</el-button>
        </div>
      </div>
      <div class='h-top-title row'>
        <div class="col-md-9 col-12">
          <h4 class='d-inline-block' v-if="$route.query.title">Search result for "{{ $route.query.title }}" </h4>
          <h5 class='d-inline-block ml-0 ml-md-3' v-if="totalItems > 0"><small>
            <em>Showing <strong>{{ showingFrom }}-{{showingTo}}</strong> results 
              out of <strong>{{ totalItems }}</strong></em>
          </small></h5>
        </div>
        <div class="col-md-3 col-12 d-none d-md-block text-right align-top">
          <el-button type="default" icon="el-icon-s-grid" class='filter-btn' 
            data-toggle="collapse" href="#collapseElm" size="small">
            FILTER</el-button>
        </div>
      </div>
      <div class="row collapse filter-collapse" id="collapseElm">
        <div class="col-12">
          <div>
            <div class='row w-100'>
              <div class="col-md-3 col-lg-2 col-12 mb-4">
                <h6 class="mb-3 font-weight-lighter">Sort by</h6>
                <div>
                  <el-radio-group  class="w-100" v-model="sort" fill="red" @change="handleSort">
                    <el-radio-button label="latest">Latest</el-radio-button>
                    <el-radio-button label="rating-desc">Most rating</el-radio-button>
                    <el-radio-button label="rating-asc">Lowest rating</el-radio-button>
                    <el-radio-button label="a-z">Title ascending</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <!-- /.col-* -->
              <div class="col-md-9 col-lg-10">
                <div class="d-md-table w-100">
                  <!-- <div class="d-md-table-cell">
                    <h6 class="mb-3 font-weight-lighter">Film type</h6>
                    <div class="fc-inner-box">
                      <el-radio v-model="type" label="all">All</el-radio>
                      <el-radio v-model="type" label="movies">Movies</el-radio>
                      <el-radio v-model="type" label="TV Series">TV Series</el-radio>
                    </div>
                  </div> -->
                  <!-- /.d-table-cell -->
                  <div class="d-md-table-cell">
                    <h6 class="mb-3 font-weight-lighter">Release</h6>
                    <div class="fc-inner-box">
                      <el-radio v-model="year" label="">All</el-radio>
                      <el-radio 
                        v-model="year" 
                        :label="i"
                        v-for="i in range(yearRange.endYear - 3, yearRange.endYear)"
                        :key="i"
                      >
                        {{ i }}
                      </el-radio>
                      <!-- FIXME year not selected on reload -->
                      <el-radio v-model="year" :label="hasDropActiveYear" v-if="hasDropActiveYear">
                        {{ hasDropActiveYear }}
                      </el-radio>
                      <el-dropdown>
                        <el-button type="primary" size="mini">
                          <span class="el-icon-more"></span>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <perfect-scrollbar id='scrollbar2'>
                            <el-dropdown-item 
                              v-for="i in range(yearRange.startYear, yearRange.endYear - 3)"
                              :key='i'
                              
                            >
                              <span @click="activeYear(i)">{{ i }}</span>
                            </el-dropdown-item>
                          </perfect-scrollbar>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <!-- /.d-table-cell -->
                </div>  
                <!-- /.d-table -->
                <h6 class="mb-3 mt-4 font-weight-lighter">Genre</h6>
                <div class="fc-inner-box">
                  <el-radio v-model="genre" label="">
                    All
                  </el-radio>
                  <el-radio 
                    v-model="genre" 
                    :label="gen"
                    v-for='(gen, i) in allGenres'
                    :key="i"
                  >
                    {{ gen | capitalize }}
                  </el-radio>
                </div>
                <!-- /.fc-inner-box -->
              </div>
              <!-- /.col-* -->
            </div>
            <!-- /.row -->
            <hr>
            <div class="text-center">
              <el-button type="primary" @click="handleFilter()">Filter Results</el-button>
            </div>
          </div>
          <!-- /div -->
        </div>
      </div>
      <!-- /.row -->
      
      <div class="row">
        <div class="col">
          <div class="alert alert-secondary alert-dark mt-3" v-if="totalCount < 1">
            <span>Sorry! no record found for your search query</span>
          </div>
        </div>
      </div>

      <div class="row">
        <FilmGrid v-for="movie in movies" v-bind:key="movie.id"
          :id='movie.id'
          :url="(movie.type == 'article' ? '/movie/' : '/tv-show/') + movie.id" 
          :avatar='movie.avatar'
          :played="movie.is_played"
          :favorite="movie.is_favorite"
          :secondaryTitle='movie.secondary_title'
          :title="movie.title"
          :year="movie.year"
          :rate='movie.rating'
          :type='movie.type'
          :watchlater='movie.watch_later_count'
        />
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <!-- TODO implement server side page-size -->
          <el-pagination
            v-if="totalCount"
            @current-change="handleSizeChange"
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="perPageItems" 
            :total="totalItems"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import FilmGrid from "../components/FilmGrid";
import Pagination from "../components/Pagination";
import Loader from "../components/Loader";
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import $ from 'jquery';
import SearchForm from '../components/SearchForm'

import { authRequest, getAppResource } from '../app/helpers';

export default {
  data() {
    return {
      loading: true,
      movies: [],
      totalCount: 0,
      currentPage: null,
      totalItems: 0,
      showingItems: 0,
      showingFrom: 0,
      showingTo: 0,
      perPageItems: 0,
      page: '',
      sort: 'latest',
      genre: '',
      search: '',
      category: '',
      title: '',
      type: 'all',
      year: '',
      filter: {
        sort: 'latest',
        type: 'all',
        genre: '',
        year: '',
      },
      allGenres: [],
      yearRange: {
        startYear: null,
        endYear: null
      },
      hasDropActiveYear: false,
    } 
  },
  components: {
    FilmGrid,
    Pagination,
    Loader,
    PerfectScrollbar,
    SearchForm,
  },
  name: "search",
  methods: {
    async fetchMovies() {
      this.loading = true;
      const self = this;
      const query = `page=${this.page}&category=${this.category}&title=${this.search}` + 
        `&sort=${this.sort}&genre=${this.genre}&title=${this.title}&year=${this.year}`;
      const request = await authRequest(this.$router, '/search?' + query);

      this.loading = request ? false : true;
      self.movies = request.results;
      self.totalCount = request.totalPage
      self.currentPage = request.currentPage
      self.totalItems = request.totalItems
      self.showingItems = request.showing
      self.perPageItems = request.limit
      this.showingFrom = request.offset + 1
      this.showingTo = request.offset + request.showing
    },

    handleSizeChange(page) {
      let params = this.$route.query;
      params = {...params, page}
      
      this.$router.push({
        query: params
      })
    },

    setQuery() {
      const route = this.$route;
      this.sort = route.query.sort || '';
      this.genre = route.query.genre || '';
      this.search = route.query.search || '';
      this.page = route.query.page || 1;
      this.category = route.query.category || '';
      this.title = route.query.title || '';
      this.year = route.query.year || '';
    },

    handleSort(v) {
      // on sort change
    },


    async getAppResources() {
      const gen = await getAppResource('genres');
      this.allGenres = gen;

      const yr = await getAppResource('release-year-range');
      this.yearRange = yr;
    },


    activeYear(year) {
      this.year = year;
      this.hasDropActiveYear = year;
    },


    handleFilter() {
      const q = this.$route.query;
      const query = {
        ...q,
        genre: this.genre,
        year: this.year,
        sort: this.sort,
        type: this.type,
        page: 1
      };

      $("#collapseElm").collapse('hide');
      
      this.$router.push({
        name: 'search',
        query
      });
    },

  },
  mounted() {
    this.$store.commit("switchCategory", 1);
    this.$store.commit('bodyClass', 'home-page');
    // this.$snack.success('You logged in successfully');
    this.setQuery();
    this.fetchMovies();
    this.getAppResources();
    console.log('mounted');
  },
  watch: {
    $route (route, f) {
      console.log('route');
      this.setQuery();
      this.fetchMovies();
    },
  }
};
</script>


<style lang="scss">
.h-top-title {
  h4 {
    color: white;
    font-weight: 300;
    font-size: 22px;
    position: relative;
    padding-bottom: 10px;
  }

  h4:before {content: "";position: absolute;width: 80px;height: 1px;background: white;bottom: 0;}

  h5 {
    color: #636363;
    font-size: 20px;

    strong {
      font-size: 14px;
    }
  }
}

.filter-collapse {
  position: relative;

  h6 {
    color: white;
  }

  > div > div {
    background: #101010;
    padding: 12px 18px;
    border-radius: 4px;
    border: 1px solid #2b2b2b;
  }

  .el-radio-button {
    display: block;

    .el-radio-button__inner {
      border-radius: 0px !important;
      width: 100%;
      border-left: 1px solid #3E3E3E;
    }
  }

  .fc-inner-box {
    background: #171717;
    padding: 4px 12px;
    border: 1px solid #1d1d1d;
    border-radius: 2px;
  }
}

#scrollbar2 {
    height: 200px;
  }

.search-from-search {

}
</style>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>